// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"413dab498b7252b4f498","418":"d07162cf2d4254fc5660","661":"e505157ed94f0450c40f"}[chunkId] + ".bundle.js";
};